"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageFromNextLocaleIsoCode = void 0;
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const locale_1 = require("./locale");
/**
 * Retrieve a culture with fallback to legacy codes support.
 * Pulled from https://github.com/prezly/prezly/blob/de9900d9890a33502780494aa3fb85c9a732b3c3/lib/model/CulturePeer.php#L91-L114
 */
function getLanguageFromNextLocaleIsoCode(languages, nextLocaleIsoCode) {
    const defaultLanguage = (0, theme_kit_core_1.getDefaultLanguage)(languages);
    if (!nextLocaleIsoCode || nextLocaleIsoCode === locale_1.DUMMY_DEFAULT_LOCALE) {
        return defaultLanguage;
    }
    const locale = theme_kit_core_1.LocaleObject.fromAnyCode(nextLocaleIsoCode);
    return (0, theme_kit_core_1.getLanguageFromLocaleIsoCode)(languages, locale);
}
exports.getLanguageFromNextLocaleIsoCode = getLanguageFromNextLocaleIsoCode;
//# sourceMappingURL=languages.js.map